<template>
  <div class="visit-distribution">
    <portal to="layout-nav-title">{{$t('wechatMiniProgram.analysis.visitDistribution')}}</portal>

    <el-date-picker
      v-model="endDate"
      type="date"
      @change="dateChange"
      :picker-options="pickerOptions"
      :placeholder="$t('wechatMiniProgram.analysis.pleaseSelectDate')">
    </el-date-picker>

    <PieEchart
      :title-text="$t('wechatMiniProgram.analysis.accessSourceSessionCnt')"
      :options="defaultOptions"
      :data="data['access_source_session_cnt']"/>
    <PieEchart
      :title-text="$t('wechatMiniProgram.analysis.accessStaytimeInfo')"
      :options="defaultOptions"
      :data="data['access_staytime_info']"/>
    <PieEchart
      :title-text="$t('wechatMiniProgram.analysis.accessDepthInfo')"
      :options="defaultOptions"
      :data="data['access_depth_info']"/>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import PieEchart from '@/components/echarts/pie-echart';
import moment from 'moment';
import { ACCESS_SOURCE_MAPPING_KEY, ACCESS_STAYTIME_INFO_MAPPING_KEY, ACCESS_DEPTH_INFO_MAPPING_KEY } from '@/constants'

@Component({
  components: {
    PieEchart
  }
})
export default class VisitDistribution extends Vue {
  endDate = moment().add('days', -1);

  data = {
    access_source_session_cnt: [],
    access_staytime_info: [],
    access_depth_info: []
  }

  defaultOptions = {
    seriesName: this.$t('wechatMiniProgram.analysis.sourceAnalysis'),
    seriesRadius: '40%',
    seriesCenter: ['30%', '50%']
  }

  get pickerOptions() {
    return {
      disabledDate: (time) => {
        return moment(time).diff(moment(new Date()), 'days') > -1;
      }
    }
  }

  mounted() {
    this.dateChange()
  }

  async fetchData(params = {}) {
    const res = (await this.$request.get(`applications/${'wx8bb4a20e2f302ca3'}/analyses/getweanalysisappidvisitdistribution`, params) || {}).list || [];
    this.data.access_source_session_cnt = (res.filter((item) => item.index === 'access_source_session_cnt')[0] || {}).item_list || [];
    this.data.access_source_session_cnt.forEach((item) => { item.name = ACCESS_SOURCE_MAPPING_KEY[item.key] });
    this.data.access_staytime_info = (res.filter((item) => item.index === 'access_staytime_info')[0] || {}).item_list || [];
    this.data.access_staytime_info.forEach((item) => { item.name = ACCESS_STAYTIME_INFO_MAPPING_KEY[item.key] });
    this.data.access_depth_info = (res.filter((item) => item.index === 'access_depth_info')[0] || {}).item_list || [];
    this.data.access_depth_info.forEach((item) => { item.name = ACCESS_DEPTH_INFO_MAPPING_KEY[item.key] });
  }

  dateChange() {
    if (this.endDate) {
      const formatTime = moment(this.endDate).format('YYYY-MM-DD');
      this.fetchData({ begin_date: formatTime, end_date: formatTime });
    } else {
      this.$message.warning('请先选择日期');
    }
  }
}

export const route = [
  {
    path: '/visit_distribution',
    name: 'visit_distribution',
    component: VisitDistribution,
    meta: {
      can: 'data_analyses.visit_distribution'
    }
  }
]
</script>

<style lang="scss" scoped>
.visit-distribution {
  margin: 20px 0 0 20px;
}
</style>
